import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class PartyInstanceService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data || [],
                pagination: response.pagination || {},
                message: response.message || 'Party atamaları getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party instance list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party instance');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message || 'Atama oluşturuldu' };
        } catch (error) {
            throw this._handleError(error, 'Failed to create party instance');
        }
    }

    async addAssignment(id, assignment) {
        try {
            const response = await this.api.addAssignment(id, assignment);
            return { success: true, data: response.data, message: response.message || 'Üye eklendi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to add assignment');
        }
    }

    async removeAssignment(id, assignmentId) {
        try {
            const response = await this.api.removeAssignment(id, assignmentId);
            return { success: true, data: response.data, message: response.message || 'Üye kaldırıldı' };
        } catch (error) {
            throw this._handleError(error, 'Failed to remove assignment');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Party instance silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete party instance');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
